export default __webpack_public_path__ + "static/6653-bcc5185ada186ef54377e9d5b9a817d5.jpg";